import axios from 'axios';
import { MasterDataURL, NotificationOrgURL } from '../../../config/UrlEndPoint';
import { OrganizationURL } from '../../../config/UrlEndPoint';

export const URL = `${MasterDataURL}dashboard`;
export const URLOrganization = `${OrganizationURL}`;
export const URLNotificationOrg = `${NotificationOrgURL}`;

// Get Bank All For use Combobox data
export function getTotalPenerimaanDonasi(filter, branch) {
  return axios.post(`${URL}/total_penerimaan_donasi`, { date: filter, branch });
}
export function getTargetPenerimaanDonasi(filter, branch) {
  return axios.post(`${URL}/target_penerimaan_donasi`, { date: filter, branch });
}

export function getTotalDonatur(filter, branch) {
  return axios.post(`${URL}/total_donatur`, { date: filter, branch });
}

export function checkWizard() {
  return axios.get(`${URLOrganization}/organization/check_wizard`,);
}

export function getTotalRetensiDonatur(filter, branch) {
  return axios.post(`${URL}/total_retensi_donatur`, { date: filter, branch });
}

export function getTotalDonationType(filter, branch) {
  return axios.post(`${URL}/total_donation_type`, { date: filter, branch });
}

export function getTotalDonationChannel(filter, branch) {
  return axios.post(`${URL}/total_channel_type`, { date: filter, branch });
}

export function getTotalDonationThisYear(filter, branch) {
  return axios.post(`${URL}/total_penerimaan_donasi_tahun_ini`, { branch: branch });
}

export function getTotalDonationThisDay(filter, branch) {
  return axios.post(`${URL}/total_penerimaan_donasi_hari_ini`, { branch: branch });
}

export function getTotalDonationThisWeek(filter, branch) {
  return axios.post(`${URL}/total_penerimaan_donasi_minggu_ini`, { branch: branch });
}

export function getTotalDonationThisMonth(filter, branch) {
  return axios.post(`${URL}/total_penerimaan_donasi_bulan_ini`, { branch: branch });
}

export function getTotalDonationProgram(filter, branch) {
  return axios.post(`${URL}/total_donation_program`, { date: filter, branch });
}

export function getTotalDonationBank(filter, branch) {
  return axios.post(`${URL}/total_donation_bank`, { date: filter, branch });
}
export function getTotalDonationEchannel(filter, branch) {
  return axios.post(`${URL}/total_donation_echannel`, { date: filter, branch });
}

export function getTotalDonationBranch(filter, branch) {
  return axios.post(`${URL}/total_donation_branch`, { date: filter, branch });
}

export function getTotalDonationCounter(filter, branch) {
  return axios.post(`${URL}/total_donation_counter`, { date: filter, branch });
}

export function getTotalDonorType(filter, branch) {
  return axios.post(`${URL}/total_donatur_type`, { date: filter, branch });
}

export function getTotalDonorIndividu(filter, branch) {
  return axios.post(`${URL}/top_donatur_individu`, { date: filter, branch });
}

export function getTotalDonorInstitusi(filter, branch) {
  return axios.post(`${URL}/top_donatur_institution`, { date: filter, branch });
}

export function getTotalDonorPremium(filter, branch) {
  return axios.post(`${URL}/top_donatur_premium`, { date: filter, branch });
}


export function getTotalDonorGender(filter, branch) {
  return axios.post(`${URL}/total_donatur_gender`, { date: filter, branch });
}



// export function getTotalDonorInstitusi(filter, branch) {
//   return axios.post(`${URL}/top_donatur_institution`, { date: filter, branch });
// }



export function getTotalNominalTransaksi(filter, branch) {
  return axios.post(`${URL}/nominal_trans_fav`, { date: filter, branch });
}

export const findNotificationOrg = (params) => {
  return axios.post(`${URLNotificationOrg}find`, params);
}

export const getCurrentMonthDonationAmount = () => {
  return axios.get(`${URL}/current_month_donation_amount`);
};

export const getTotalDonor = () => {
  return axios.get(`${URL}/total_donor`);
}

export const getCurrentMonthDonor = () => {
  return axios.get(`${URL}/current_month_donor`);

}

export const getTotalProgram = () => {
  return axios.get(`${URL}/total_program`);
}

export const getTotalProject = () => {
  return axios.get(`${URL}/total_project`);
}

export const getTotalFundType = () => {
  return axios.get(`${URL}/total_fund_type`);
}

export const getTopProgram = () => {
  return axios.get(`${URL}/top_program`);
}

export function dashboardGetTotalDonation(type) {
  return axios.get(`${URLOrganization}/dashboard/get_total_donation/${type}`);
}

export function dashboardGetTotalDonationCount() {
  return axios.get(`${URLOrganization}/dashboard/get_total_donation_count`);
}







